import React from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom';


export default function SecretCodePage(props) {
    const location = useLocation();
    const navigate = useNavigate()
    const submit = () => {
        navigate(`/${location.pathname}`);
    }
    
    return (
        <div>
            <div className='row center'>
                <div className='secretCodeForm'>
                    <div className="row center">
                        Enter The "Entry" Code to access {location.pathname}
                    </div>
                    <form className='inputForm' onSubmit={(e)=>submit()}>
                        <div className='row center'>
                            <input className='inputField' onChange={(e)=>localStorage.setItem("secretCode", e.target.value)}></input>
                        </div>
                        <div className='row center'>
                            <button type="submit" className='secretButton'>SUBMIT</button>
                        </div>  
                    </form>
                    <div className="row center">
                        <Link to='/'>Back to Homepage</Link>   
                    </div>
                </div>
            </div>
            
        </div>
    )
}
